import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import './home.css';

export default function Home({ data = 0, totalDonations }) {
  return (
    <div>
      <div className="bg-doner d-flex flex-row">
        <span className='text-white mx-auto my-auto' style={{ fontSize: "12vw" }}>#BanjirMission</span>
      </div>
      <h1 className="m-3 text-center w-100" style={{ fontSize: "32pt" }}>Target: RM 1000</h1>
      <LinearProgress variant="determinate" color={"success"} value={Math.round((totalDonations / 1000) * 100)} className="w-75 mx-auto" />
      <div className="d-flex w-100 donation-card">
        <div className="card w-100 m-2 shadow text-white" style={{ backgroundColor: "#fd79a8" }}>
          <div className="card-body">
            <div className="doner-container d-flex flex-column align-items-center">
              <h1 className='total-doners text-center mb-2'>Total Donors:</h1>
              {
                data ?
                  <p style={{fontSize: "40pt"}}>{data.length}</p>
                  :
                  null
              }
            </div>
          </div>
        </div>
        <div className="card w-100 m-2 shadow text-white" style={{ backgroundColor: "#a29bfe" }}>
          <div className="card-body">
            <div className="doner-container d-flex flex-column align-items-center">
              <h1 className='total-doners text-center mb-2'>Total Funds Raised (RM):</h1>
              <p style={{fontSize: "40pt"}}>{totalDonations}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}